export default __webpack_public_path__ + "static/media/Standard40.ec37893e.png";